import { AxiosPromise, AxiosStatic } from "axios";
import {
  EarningsCalendarTimelineResponse,
  UpcomingEarningsResponse,
} from "../types";

export const getEarningsCalendarTimeline =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (
    dealId: string,
    commitmentId?: string
  ): AxiosPromise<EarningsCalendarTimelineResponse> =>
    await appAxios.get(`${serverURL}/earnings-calendar/deal/${dealId}`, {
      ...(commitmentId ? { params: { commitmentId } } : {}),
      withCredentials: true,
    });

export const getUpcomingEarnings =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<UpcomingEarningsResponse> =>
    await appAxios.get(`${serverURL}/earnings-calendar/upcoming`, {
      withCredentials: true,
    });
